
import  { ChangeHistory } from '../../../../assets/js/modules/changeHistory';

export default class InvoicesChangeHistory{
    constructor(){
        this.changeHistoryContainer = document.querySelector('#change-history-container-invoices');
        if(!this.changeHistoryContainer) return;
        this.event();  
    }
    event(){
        if (this.changeHistoryContainer) {
            const modelName = 'invoices';
            const objectId = invoicesIdVar;
            const fieldsToShow = ['designation_number', 'status', 'amount'];
            const fieldLabels = {
                designation_number: 'Bezeichnungsnummer',
                status: 'Status',
                amount: 'Betrag'
            };
            const changeHistory = new ChangeHistory(modelName, objectId);
            changeHistory.renderChanges('change-history-container-invoices', fieldsToShow, fieldLabels);
        }
    }
}